import {useSelector} from "react-redux";

export const useFavorites = () => {
	return useSelector((state) => {
		return state.favorites?.data || [];
	});
}